<template>
  <div :class="$style.container">
    <Navigation />
    <main :class="$style.body">
      <div :class="$style.page">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import Navigation from './Navigation';

export default {
  name: 'DashboardLayout',
  components: {
    Navigation,
  },
};
</script>

<style src="./Layout.module.scss" lang="scss" module />
